import { filter } from "lodash";

export default {
  namespaced: true,
  state: {
    current_order: {},
    activeTab: 'past',
    pastOrders: [],
    comingOrders: [],
    orderCurrentPage: 1,
    allOrders: {
      count: 0,
      limit: 0,
      total_page: 0,
      orders: [],
    },
    orderNotification: {
      show: false,
      detail: {},
    },
  },
  getters: {
    currentOrder: state => state.current_order,
    activeTab: state => state.activeTab,
    pastOrders: state => state.pastOrders,
    comingOrders: state => state.comingOrders,
    allOrders: state => state.allOrders,
    orderCurrentPage: state => state.orderCurrentPage,
    orderNotification: state => state.orderNotification,
  },
  mutations: {
    setCurrentOrderMutate(state, data) {
      state.current_order = data;
    },
    allOrdersMutate(state, data) {
      state.allOrders = data;
    },
    updateOrderStatusMutate(state, obj){
      state.allOrders.orders.map(item => {
        if(item.id == obj.id){
          item.status = obj.status;
          // if the selected current status has got update overide it
          if(state.current_order.id == obj.id){
            state.current_order = obj;
          }
          // for notification
          if(state.orderNotification.detail.id == obj.id){
            state.orderNotification = {
              show: true,
              detail: obj,
            }
          }
        }
      });
      // if we got notification for order status complate remove it after 5sec and check for another pending
      if(obj.status == 'completed'){
        // hide the notification after 5 sec
        setTimeout(() => {
          state.orderNotification = {
            show: false,
            detail: {},
          }
          // now check for any linedUp  orders
          let linedUpOrders =  _.filter(state.allOrders.orders, function(order) {
            return order.status =='pending' || order.status =='ready' || order.status =='preparing';
          });
          if(linedUpOrders.length > 0){
            state.orderNotification = {
              show: true,
              detail: linedUpOrders[0],
            }
          }
        }, 5000)
      }
    
    },
    orderCurrentPageMutate(state, data) {
      state.orderCurrentPage = data;
    },
    activeTabMutate(state, data) {
      state.activeTab = data;
    },
    pastOrdersMutate(state, data) {
      state.pastOrders = data;
    },
    comingOrdersMutate(state, data) {
      state.comingOrders = data;
    },
    addNewOrderItemsMutate(state, data){
      state.allOrders = {
        count: data.count,
        limit: data.limit,
        total_page: data.total_page,
        orders: [...state.allOrders.orders, ...data.orders],
      };
    },
    orderNotificationMutate(state, data) {
      state.orderNotification = data;
    },
  },
  actions: {
    setCurrentOrder(context, data) {
      context.commit("setCurrentOrderMutate", data);
    },
    setAllOrders(context, data) {
      context.commit("allOrdersMutate", data);
    },
    updateOrderStatus(context, data) {
      context.commit("updateOrderStatusMutate", data);
    },
    setOrderCurrentPage(context, data) {
      context.commit("orderCurrentPageMutate", data);
    },
    setActiveTab(context, data) {
      context.commit("activeTabMutate", data);
    },
    setPastOrders(context, data) {
      context.commit("pastOrdersMutate", data);
    },
    setComingOrders(context, data) {
      context.commit("comingOrdersMutate", data);
    },
    addNewOrderItems(context,data){
      context.commit("addNewOrderItemsMutate", data);
    },
    setOrderNotification(context,data){
      context.commit("orderNotificationMutate", data);
    },
  }
}